import { Directive, ElementRef, Injector, Input } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

@Directive({
	standalone: true,
	selector: 'session-attachments'
})
export class SessionAttachmentsWrapperDirective extends UpgradeComponent {
	@Input() public session: any;
	@Input() public group: any;
	@Input() public user: any;
	@Input() public readonlyMode: boolean;
	@Input() public analyticsCategory: string;
	@Input() public analyticsLabel: string;
	@Input() public activityName: any;
	@Input() public options: any;

	constructor (
		elementRef: ElementRef,
		injector: Injector
	) {
		super('sessionAttachments', elementRef, injector);
	}
}
